import React from 'react'
import {
  i18nTranslate,
  isExpressCheckout,
  getLocaleCodeFromUrl,
  getLiveEventStatus,
  convertToBoolean,
} from 'src/utils'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { APPConfig, getBuyNowInPDP, IS_BROWSER } from 'config/appConfig'
import { catalogContainer, customerContainer } from 'src/models'

class RegionRestrictionBanner extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { regionSelectorUrl, isInDialog } = this.props
    const homeMarket = customerContainer?.getUserHomeCountry() || ''
    const curLocale = getLocaleCodeFromUrl({
      url: (typeof window !== 'undefined' ? window.location.href : '') || '',
      at: 'pathParam',
      defaultLocale: APPConfig.getAppConfig().defaultLocale || 'en_US',
      isReverseType: true,
    })
    const [language, activeCountryCode] = curLocale.includes('_')
      ? curLocale.split('_')
      : curLocale.split('-')

    if (
      homeMarket === '' ||
      activeCountryCode === '' ||
      (!isInDialog && homeMarket === activeCountryCode) ||
      convertToBoolean(getLiveEventStatus())
    ) {
      return null
    }

    return (
      <div>
        <span>
          {i18nTranslate('market.account', 'Your account is registered in', {
            nameSpace: 'ssr-resource',
          })}{' '}
          <strong>{homeMarket || ' '}</strong>,{' '}
          {i18nTranslate(
            'market.unauthorized',
            ` which is not authorized to make purchases or perform business activities in `,
            {
              nameSpace: 'ssr-resource',
            }
          )}{' '}
          <strong>{activeCountryCode || ' '}</strong>,{' '}
          {i18nTranslate(
            'market.navigate',
            ` You may continue to browse this site. `,
            {
              nameSpace: 'ssr-resource',
            }
          )}{' '}
          {regionSelectorUrl && (
            <>
              <br />
              <u>
                <strong>
                  <a
                    href={regionSelectorUrl}
                    title={i18nTranslate(
                      'homeCountry.region',
                      'Select Region',
                      {
                        nameSpace: 'ssr-resource',
                      }
                    )}>
                    {i18nTranslate('homeCountry.region', 'Select Region', {
                      nameSpace: 'ssr-resource',
                    })}
                  </a>
                </strong>
              </u>{' '}
            </>
          )}
        </span>
      </div>
    )
  }
}

export { RegionRestrictionBanner }
